import { Container, Row } from 'react-bootstrap';

import Footer from '../sections/Footer';
import Menu from '../sections/Menu';
import PageMeta from '../seo/PageMeta';

function TermsOfService() {

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/data/regulamin_eGodziny.pdf';
    link.download = 'regulamin_eGodziny.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <PageMeta path="/regulamin" />
      <Menu />

      <div style={{ flex: 1 }}>
        <Container className='my-4'>
          <Row className='py-3'>
            <h3>Regulamin</h3>
            <p>
              Witamy w serwisie eGodziny. Niniejszy regulamin określa zasady korzystania z naszych usług oraz prawa i obowiązki użytkowników.
            </p>
          </Row>

          <Row className='py-3'>
            <div className="d-flex justify-content-center">
              <button 
                onClick={handleDownload}
                className="btn btn-primary btn-lg"
                style={{
                  backgroundColor: '#407EF9',
                  borderColor: '#407EF9',
                  borderRadius: '25px',
                  padding: '12px 30px',
                  fontSize: '16px',
                  fontWeight: 'bold'
                }}
              >
                Pobierz regulamin (PDF)
              </button>
            </div>
          </Row>
        </Container>
      </div>

      <Footer />
    </div>
  );
}

export default TermsOfService;
